import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateLanguage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Language/Create");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}
class GetAllLanguages extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Language/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class DeleteALanguage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Language/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class UpdateALanguage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Language/Update");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class GetASingleLanguage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Language/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
export {
  CreateLanguage,
  GetAllLanguages,
  DeleteALanguage,
  UpdateALanguage,
  GetASingleLanguage,
};
